export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;
  static #initialized = false;
  static #loading = false;
  static #apiReady = false;
  static #allowed = false;
  static #currentProduct = null;
  static changeEvent = 'mvurra:recently-viewed-change';

  static initialize() {
    if (this.#initialized) return;
    this.#initialized = true;
    document.addEventListener('visitorConsentCollected', (event) => {
      this.#apiReady = typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function';
      this.#syncConsent(event.detail?.preferencesAllowed !== false);
    });
    this.#loadPrivacyApi();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.#loadPrivacyApi(), { once: true });
    }
    window.addEventListener('load', () => this.#loadPrivacyApi(), { once: true });
  }

  static #loadPrivacyApi() {
    if (typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function') {
      this.#apiReady = true;
      this.#syncConsent();
      return;
    }
    if (this.#loading || typeof window.Shopify?.loadFeatures !== 'function') return;
    this.#loading = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], (error) => {
        this.#loading = false;
        this.#apiReady = !error && typeof window.Shopify?.customerPrivacy?.preferencesProcessingAllowed === 'function';
        this.#syncConsent();
      });
    } catch {
      this.#loading = false;
    }
  }

  static #syncConsent(eventAllowsPreferences = true) {
    this.#allowed = false;
    if (this.#apiReady && eventAllowsPreferences) {
      try {
        this.#allowed = window.Shopify.customerPrivacy.preferencesProcessingAllowed() === true;
      } catch {
        this.#allowed = false;
      }
    }
    if (!this.#allowed) {
      this.#removeStoredProducts();
    } else if (this.#currentProduct) {
      this.#storeProduct(this.#currentProduct);
    }
    document.dispatchEvent(new CustomEvent(this.changeEvent));
  }

  static isAllowed() {
    if (!this.#apiReady || !this.#allowed) return false;
    try {
      return window.Shopify.customerPrivacy.preferencesProcessingAllowed() === true;
    } catch {
      return false;
    }
  }

  static addProduct(productId) {
    this.#currentProduct = String(productId);
    if (this.isAllowed()) this.#storeProduct(this.#currentProduct);
  }

  static #storeProduct(productId) {
    if (!this.isAllowed()) return;
    const products = this.getProducts().filter((id) => id !== productId);
    products.unshift(productId);
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(products.slice(0, this.#MAX_PRODUCTS)));
    } catch {}
  }

  static #removeStoredProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {}
  }

  static clearProducts() {
    this.#currentProduct = null;
    this.#removeStoredProducts();
  }

  static getProducts() {
    if (!this.isAllowed()) return [];
    try {
      const products = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return Array.isArray(products) ? products.filter((id) => typeof id === 'string').slice(0, this.#MAX_PRODUCTS) : [];
    } catch {
      return [];
    }
  }
}

RecentlyViewed.initialize();

